module.exports = __webpack_public_path__ + "assets/img/head.91d06283.png";